var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7083 7.62506C15.7833 4.60006 12.9666 2.8584 9.99996 2.8584C8.51663 2.8584 7.07496 3.29173 5.75829 4.10007C4.44163 4.91673 3.25829 6.1084 2.29163 7.62506C1.45829 8.9334 1.45829 11.0584 2.29163 12.3667C4.21663 15.4001 7.03329 17.1334 9.99996 17.1334C11.4833 17.1334 12.925 16.7001 14.2416 15.8917C15.5583 15.0751 16.7416 13.8834 17.7083 12.3667C18.5416 11.0667 18.5416 8.9334 17.7083 7.62506ZM9.99996 13.3667C8.13329 13.3667 6.63329 11.8584 6.63329 10.0001C6.63329 8.14173 8.13329 6.6334 9.99996 6.6334C11.8666 6.6334 13.3666 8.14173 13.3666 10.0001C13.3666 11.8584 11.8666 13.3667 9.99996 13.3667Z",
    fill: "#28A1E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.6167C8.69167 7.6167 7.625 8.68337 7.625 10C7.625 11.3084 8.69167 12.375 10 12.375C11.3083 12.375 12.3833 11.3084 12.3833 10C12.3833 8.6917 11.3083 7.6167 10 7.6167Z",
    fill: "#28A1E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.c5d06db612a263f63d524f97bc5bd097.svg";
export { ForwardRef as ReactComponent };